import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";
import { PropCalendarClass } from "./PropCalendarClass";

export class PropSets extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      bookList: [],
      setListEvents: "",
     
      classSelected: false,
      selectedClassId : "",
      events: [
        {
          id: 1,
          title: "Test",
          url: "/#/managesets",
          start: "2019-03-09T12:00:00",
          end: "2019-03-09T12:30:00"
        }
      ]
    };
  }

  componentDidMount = () => {
    this.getSets();
  };

  getSets = async () => {
    this.setState({ loaded: false });

  
      let bookRequest = new Belfastpilatesappspotcom.BookRequest();
      bookRequest.codeTag = localStorage.getItem("globalBid");
      bookRequest.userId = localStorage.getItem("userId");
      bookRequest.identifier = "CREATE";

      await api("bookApiV1BookGetAllByIdentifier", bookRequest).then(res => {
        if (res.data) {
          if (Array.isArray(res.data.bookList)) {
            res.data.bookList.forEach(e => {
              if (e.date) {
                e.date = e.date.toJSON();
              }
            });
          }
          let bookResponse = Belfastpilatesappspotcom.BookResponse.constructFromObject(
            res.data
          );
          console.log(bookResponse);

          if (bookResponse.errorCode === 0) {
            this.setState({
              bookList: bookResponse.bookList
            });
          } else {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail:
                "Books could not be retrieved, please refresh and try again",
              life: 3000
            });
          }
        } else {
          console.log("bookApiV1BookGetAllByIdentifier has failed");
        }
      });

      this.setState({
        setListEvents: this.bookListsToEvents(),
        loaded: true
      });
    
  };

  bookListsToEvents = () => {
    let eventArray = [];
    let bookListsResult = this.state.bookList;

    if (Array.isArray(bookListsResult)) {
      bookListsResult.forEach(f => {
        let instructorNameArray = [];

        if (f.instructorDetails) {
          f.instructorDetails.forEach(g => {
            instructorNameArray.push(" " + g.firstName + " " + g.surname);
          });
        }

        eventArray.push({
          id: f.id,
          title: f.level + "\n" + instructorNameArray,
          start: f.date,
          backgroundColor:
            f.level === "Intermediate/Advanced"
              ? "#f44336"
              : f.level === "Progressive/Intermediate"
              ? "#4caf50"
              : f.level === "Beginner/Progressive"
              ? "#3f51b5"
              : f.level === "Reformer"
              ? "#e91e63"
              : f.level === "Mum and Baby"
              ? "#ffc107"
              : f.level === "Antenatal"
              ? "#ff9800"
              : f.level === "Kids"
              ? "#00bcd4"
              : f.level === "Mature Movers"
              ? "#9e3dff"
              : "black"
        });
      });
    }

    return eventArray;
  };

  back = () => {
      this.setState({selectedClassId : "", classSelected : false});
  }

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        {!this.state.classSelected ? (
          <React.Fragment>
          <div className="ui-g-12">
            <label style={{ color: "#00aeef" }}>Sync for latest changes</label>
            <pr.Button
              className="secondary-btn"
              label="Sync Now"
              icon="pi pi-replay"
              onClick={() => {
                this.getSets();
              }}
              style={{ float: "right" }}
            />
          </div>
      
        <div className="ui-g-12">
          <pr.Schedule
            events={this.state.setListEvents}
            eventStartEditable={false}
            onEventClick={e => {

              console.log(e.calEvent.id);
              this.setState({selectedClassId : e.calEvent.id, classSelected : true});

            }}
          />
        </div>
        </React.Fragment>
          ) : (
            <div className="ui-g-12">
           <PropCalendarClass 
           bookId={this.state.selectedClassId}
           back={this.back}/>
           </div>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/PropSets.js